module.exports = __webpack_public_path__ + "img/ring_g_skip_0_0@2x.5caf77e4.png";